import { tsUtils } from '@neo-one/ts-utils';
import { BuiltinInstanceMemberCall } from '../BuiltinInstanceMemberCall';
export class BufferSlice extends BuiltinInstanceMemberCall {
    canCall(_sb, _func, node) {
        return tsUtils.argumented.getArguments(node).length <= 2;
    }
    emitCall(sb, func, node, optionsIn, visited) {
        const options = sb.pushValueOptions(optionsIn);
        const expr = tsUtils.expression.getExpression(func);
        if (!visited) {
            sb.visit(expr, options);
        }
        sb.emitHelper(node, options, sb.helpers.unwrapBuffer);
        const args = tsUtils.argumented.getArguments(node);
        if (args.length === 1) {
            sb.visit(args[0], options);
            sb.emitHelper(node, options, sb.helpers.unwrapNumber);
            sb.emitHelper(node, options, sb.helpers.bufferSlice({}));
        }
        else if (args.length === 2) {
            sb.visit(args[1], options);
            sb.emitHelper(node, options, sb.helpers.unwrapNumber);
            sb.visit(args[0], options);
            sb.emitHelper(node, options, sb.helpers.unwrapNumber);
            sb.emitHelper(node, options, sb.helpers.bufferSlice({ hasEnd: true }));
        }
        if (optionsIn.pushValue) {
            sb.emitHelper(node, options, sb.helpers.wrapBuffer);
        }
        else {
            sb.emitOp(node, 'DROP');
        }
    }
}

//# sourceMappingURL=slice.js.map
